import "./Methodology.css";
import tutor from "../../../image/tutor.svg";
import pc from "../../../image/pc.svg";

function Methodology() {
  return (
    <section className="methodology">
      <div className="methodology__block ">
        <img
          className="methodology__img"
          src={tutor}
          alt="картинка наставника"
        ></img>
      </div>
      <div className="methodology__block methodology__block_description">
        <h2 className="methodology__title">Помощь и поддержка</h2>
        <p className="methodology__subtitle">
          Если в процессе обучения возникнут сложности, вы всегда сможете задать
          вопрос своему наставнику.
        </p>
        <p className="methodology__subtitle">
          Раз в несколько уроков вы будете получать большое задание, которое
          нужно будет сдавать на проверку. Проверяющий внимательно изучит вашу
          работу, найдет ошибки и поможет вам стать лучше.
        </p>
      </div>
      <div className="methodology__block methodology__block_description methodology__block_order ">
        <h2 className="methodology__title">Методика обучения</h2>
        <p className="methodology__subtitle">
          Весь учебный материал структурирован по принципу «спирального
          обучения». Сначала вы получаете базовые знания, а затем на каждом
          витке спирали углубляетесь в изученные темы, доводя их понимание до
          совершенства. Такой подход упрощает обучение и гарантирует, что вы не
          пропустите ничего важного.
        </p>
      </div>
      <div className="methodology__block">
        <img
          className="methodology__img"
          src={pc}
          alt="картинка наставника"
        ></img>
      </div>
    </section>
  );
}

export default Methodology;
